import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/service-cases/$id/audit')({
  component: CaseAuditTab,
})

function CaseAuditTab() {
  return (
    <p className="text-sm text-muted-foreground p-4">
      Context snapshots, approval snapshots, and business events will appear here.
    </p>
  )
}
